<template>
    <base-page :title="$t('l.sim_manage')" icon="ios-card">
        <Row slot="extra" type="flex" justify="end">
            <Col><input type="file" @input="importDeviceInfo" ref="uploadInput" style="display: none;" accept=".csv"></Col>
<!--            <Col class="margin-left-5">-->
<!--                <Button type="primary" icon="logo-yen"  :disabled="batch.ids.length === 0" @click="onBatchClick">{{$t('l.pay')}}-->
<!--                    <Badge :count="batch.ids.length"></Badge>-->
<!--                </Button>-->
<!--            </Col>-->
<!--            <Col class="margin-left-5">-->
<!--                <Button type="primary" icon="md-list"  :disabled="order.list.length === 0" @click="onShowOrder">{{$t('l.order')}}-->
<!--                    <Badge :count="order.list.length"></Badge>-->
<!--                </Button>-->
<!--            </Col>-->
            <Col class="margin-left-5">
                <Button @click="loadData()">{{$t('l.fresh')}}</Button>
            </Col>
            <Col class="margin-left-5">
                <Button v-if="$ifauth('fun_sim_import')" @click="()=>{$refs.uploadInput.click()}" :loading="loading.upload">
                    {{$t('l.import')}}
                </Button>
            </Col>
            <Col class="margin-left-5">
                <Input class="search-keyword" v-model="table.page.keyword" search
                       suffix="ios-search" :placeholder="$t('l.remark101')"
                       @on-search="loadData(1)"
                       @on-change="onSearch" />
            </Col>
        </Row>

        <template>
            <Row class="full">
                <Row :gutter="20">
                    <Col span="7">
                            <div>
                                <div id="sims" style="width:360px; height:360px"></div>
                            </div>
                    </Col>
                    <Col span="17">
                        <Table stripe border :columns="table.columns" :data="table.data" :loading="table.loading"
                               @on-select-cancel="onSelectCancel"
                               @on-selection-change="onSelectionChange">
                            <template slot-scope="{row, index}" slot="flow">
                                {{(row.flow_used/1024).toFixed(2)}}/{{(row.flow_total/1024).toFixed(2)}}
                            </template>
                            <template slot-scope="{row, index}" slot="device_name">
                                <template v-if="row.dname">
                                    <Poptip trigger="hover" placement="bottom" word-wrap :width="300" transfer>
                                        <span>{{row.dname}}</span>
                                        <div slot="content">
                                            <p>{{row.cname}}
                                                <template v-if="row.j_location">{{row.j_location.building.name}}
                                                    {{row.j_location.unit.name}} {{row.j_location.door.name}}
                                                </template>
                                                {{row.dname}}
                                            </p>
                                            <p v-if="row.j_region">{{row.j_region.province.name}} {{row.j_region.city.name}}
                                                {{row.j_region.area.name}}</p>
                                        </div>
                                    </Poptip>
                                </template>
                                <template v-else>
                                    <span>{{$t('l.unbound')}}</span>
                                </template>
                            </template>
                        </Table>
                        <Row type="flex" justify="space-around" style="position: relative;">
                            <div v-if="table.selected.length > 0" style="position: absolute;left: 0;top: 6px;">
                                <Button icon="md-checkbox-outline" type="primary" @click="addToBatch(...table.selected)">{{$t('l.add_batch')}}</Button>
                            </div>
                            <Col>
                                <Page size="small"
                                      :current="table.page.current"
                                      :page-size="table.page.size"
                                      :total="table.page.total"
                                      :page-size-opts="table.page.sizeOptions"
                                      show-elevator show-sizer show-total
                                      @on-page-size-change="($event)=>{table.page.size=$event;loadData(1)}"
                                      @on-change="loadData">
                                </Page>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Row>
        </template>
        <lg-modal :title="$t('l.sim_info')" :show="modal.showCard" :loading="modal.loading"
                  @on-submit="modal.loading=false; modal.showCard=false;"
                  @on-cancel="modal.loading=false; modal.showCard=false;" :confirm-text="$t('l.close')" :show-cancel="false">
            <Form :model="modal.card" :label-width="120">
                <!--<FormItem :label="$t('l.operator')" class="form-item">-->
                    <!--<span class="text-font-size">{{modal.card.operator}}</span>-->
                <!--</FormItem>-->
                <FormItem :label="$t('l.from_card')+'：'" class="form-item">
                    <span class="text-font-size">{{modal.card.card_from==0?$t('l.ali_cloud'):modal.card.card_from==1?$t('l.auto_unicom'):modal.card.card_from==2?$t('l.china_mobile'):$t('l.other')}}</span>
                </FormItem>
                <FormItem label="ICCID：" class="form-item">
                    <span class="text-font-size">{{modal.card.iccid}}</span>
                </FormItem>
                <FormItem :label="$t('l.elevator_name')+'：'" class="form-item">
                    <span class="text-font-size">{{modal.card.dname}}（{{modal.card.device_name}}）</span>
                </FormItem>
                <FormItem :label="$t('l.location')+'：'" class="form-item">
                    <span>{{modal.card.address}}{{modal.card.cname}}</span>
                </FormItem>
                <FormItem :label="$t('l.card_state')+'：'" class="form-item">
                    <span class="text-font-size">{{modal.card.card_status}}</span>
                </FormItem>
                <FormItem :label="$t('l.net_type')+'：'" class="form-item">
                    <span class="text-font-size">{{modal.card.card_gen}}G</span>
                </FormItem>
                <FormItem :label="$t('l.card_open_time')+'：'" class="form-item">
                    <span class="text-font-size">{{new Date(modal.card.open_time).pattern('yyyy-MM-dd')}}</span>
                </FormItem>
                <FormItem :label="$t('l.card_end_time')+'：'" class="form-item">
                    <span class="text-font-size">{{new Date(modal.card.expire_date).pattern('yyyy-MM-dd')}}</span>
                </FormItem>
                <FormItem class="form-item" v-if="modal.card.expire_date < pageVars.now" :label="$t('l.write_off_time')+'：'">
                    <span class="text-font-size">{{new Date(modal.card.force_closing_time).pattern('yyyy-MM-dd')}}</span>
                </FormItem>
                <FormItem :label="$t('l.package')+'：'" class="form-item">
                    <Tabs v-if="modal.card.packages&&modal.card.packages.length">
                        <TabPane v-for="(taocan) in modal.card.packages" :key="taocan.offerName"
                                 :label="taocan.offerName.substr(taocan.offerName.lastIndexOf('-')+1)">
                            <ul>
                                <li class="text-font-size">{{$t('l.package_name')}} {{taocan.offerName}}</li>
                                <li class="text-font-size">{{$t('l.effective_time')}} {{new Date(taocan.effectiveTime).pattern('yyyy-MM-dd')}}</li>
                                <li class="text-font-size">{{$t('l.deadline')}} {{new Date(taocan.expireTime).pattern('yyyy-MM-dd')}}</li>
                            </ul>
                        </TabPane>
                    </Tabs>
                    <span class="text-font-size" v-else>{{$t('l.no_package_msg')}}</span>
                </FormItem>
            </Form>
        </lg-modal>
        <Drawer :title="current.drawerTitle" width="600" placement="left" :closable="false" v-model="batch.showDrawer">
            <recharge-list :is-single="false" v-show="current.drawer === 'recharge'" :ids="batch.ids" ref="rechargeList"
                           @order-created="onOrderCreated"></recharge-list>
            <order-list v-show="current.drawer === 'order'" :list="order.list"
                        @order-refresh="loadMyOrder"></order-list>
        </Drawer>
    </base-page>
</template>

<script>
    import ResView from "../my-components/res-view";
    import BasePage from "../my-components/base-page";
    import util from '@/libs/util';
    import LgModal from "../my-components/lg-modal";
    import echarts from "echarts";
    import {SimCard, Taocan, reCorrectLineArr} from "./modules/sim-card-entity";
    import RechargeList from "./component/recharge-list";
    import OrderList from "./component/order-list";

    export default {
        name: 'page-sim',
        components: {OrderList, RechargeList, LgModal, BasePage, ResView},
        data() {
            return {
                value1: [],
                pageVars: {
                    now: new Date().getTime()
                },
                spliter: {
                    l_r: 0.2,
                    t_b: 0.5
                },
                loading: {
                    upload: false
                },
                pool: {
                    list: [],
                    current: 0,
                    unit_size: 0
                },
                table: {
                    loading: false,
                    selected: [],
                    columns: [
                        {
                            type: 'selection',
                            width: 80,
                            align: 'center',
                        },
                        {
                            title: 'ICCID',
                            align: 'center',
                            key: 'iccid',
                            width: 200
                        },
                        {
                            title: this.$t('l.terminal'),
                            align: 'center',
                            key: 'device_name',
                        },
                        {
                            title: this.$t('l.card_state'),
                            align: 'center',
                            key: 'card_status',
                        },
                        {
                            title: this.$t('l.flow_data') + "(MB)",
                            align: 'left',
                            key: 'flow',
                            slot: 'flow',
                            width: 120,
                        },
                        {
                            title: this.$t('l.package_end_time'),
                            align: 'center',
                            key: 'end_time',
                            render: (h, params) => {
                                return h('span', params.row.end_time?params.row.end_time:"--")
                            }
                        },
                        // {
                        //     title: '激活时间/强制激活时间',
                        //     align: 'center',
                        //     key: 'active_time',
                        //     render: (h, params) => {
                        //         return h('span', {
                        //             style: {
                        //                 color: params.row.force_active_time ? 'blue' : 'auto'
                        //             }
                        //         }, new Date(params.row.active_time || params.row.force_active_time).pattern('yyyy-MM-dd'))
                        //     }
                        // },
                        {
                            title: this.$t('l.operation'),
                            key: "action",
                            fixed: 'right',
                            align: "center",
                            render: (h, params) => {
                                let btns = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.modal.card = params.row;
                                                this.modal.showCard = true;
                                            },
                                        }
                                    }, this.$t('l.detail')),
                                    // h('Button', {
                                    //     props: {
                                    //         type: 'primary',
                                    //         size: 'small'
                                    //     },
                                    //     style: {
                                    //         marginRight: '8px'
                                    //     },
                                    //     on: {
                                    //         click: () => {
                                    //
                                    //         }
                                    //     }
                                    // }, '充值'),
                                    // h('Button',{
                                    //     props: {
                                    //         type: 'error',
                                    //         size: 'small'
                                    //     },
                                    //     on:{
                                    //         click: () => {
                                    //
                                    //         }
                                    //     }
                                    // },'删除'),
                                    // ])
                                    //     }, "查看")
                                ];
                                // if (this.$ifauth('fun_del_sim')) {
                                //     btns.push(h('Button', {
                                //         props: {
                                //             type: 'error',
                                //             size: 'small'
                                //         },
                                //         on: {
                                //             click: () => {
                                //                 this.$Modal.confirm({
                                //                     title: '删除',
                                //                     content: `确定删除SIM卡【${params.row.iccid}】资料？`,
                                //                     onOk: this.deleteSim.bind(this, params.row.iccid)
                                //                 })
                                //             }
                                //         }
                                //     }, '删除'))
                                // }
                                return h('ButtonGroup', btns)
                            }
                        },

                    ],
                    data: [],
                    page: {
                        current: 1,
                        size: 10,
                        total: 0,
                        sortKey: 'create_time',
                        sortMethod: 'desc',
                        keyword: ''
                    }
                },
                modal: {
                    showCard: false,
                    title: this.$t('l.sim_info'),
                    loading: false,
                    currentIndex: -1,
                    card: {}
                },
                current: {
                    drawer: 'recharge',
                    drawerTitle:  this.$t('l.pay')
                },
                batch: {
                    ids: [],
                    showDrawer: false
                },
                order: {
                    list: []
                },
                cardStatusChar:{},
                echartsData:{
                    noActivedCount:0,
                    normalCount:0,
                    oweCount:0,
                    stopCount:0,
                    cancelSimCount:0,
                    soonExpireCount:0,
                    flowUserdCount:0,
                    flowUserdAndExpireCount:0
                }
            };
        },
        computed: {
            simEcharts(){
                return{
                    title: {
                        text: this.$t('l.sim_statistics'),
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        left: 'left',
                        type:'scroll',
                        y:'bottom',
                        data: [this.$t('l.inactivated'), this.$t('l.normal'), this.$t('l.arrears'), this.$t('l.out_service'), this.$t('l.account_cancel'), this.$t('l.will_expire'), this.$t('l.package_will_out'), this.$t('l.package_will_out2')]
                    },
                    series: [
                        {
                            name: this.$t('l.number'),
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: [
                                {value: this.echartsData.noActivedCount, name: this.$t('l.inactivated')},
                                {value: this.echartsData.normalCount, name:  this.$t('l.normal')},
                                {value: this.echartsData.oweCount, name: this.$t('l.arrears')},
                                {value: this.echartsData.stopCount, name: this.$t('l.out_service')},
                                {value: this.echartsData.cancelSimCount, name: this.$t('l.account_cancel')},
                                {value: this.echartsData.soonExpireCount, name: this.$t('l.will_expire')},
                                {value: this.echartsData.flowUserdCount, name: this.$t('l.package_will_out')},
                                {value: this.echartsData.flowUserdAndExpireCount, name: this.$t('l.package_will_out2')},
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }
            },
        },
        watch:{
            simEcharts:{
                handler(newVal, oldVal) {
                    if (this.cardStatusChar) {
                        if (newVal) {
                            this.drawChart(this.cardStatusChar, "sims", newVal);
                        } else {
                            this.drawChart(this.cardStatusChar, "sims", oldVal);
                        }
                    } else {
                        this.drawChart(this.cardStatusChar, "sims", this.simEcharts);
                    }
                },
                deep: true
            },
        },
        methods: {
            onSearch() {
                if (!this.table.page.keyword) this.loadData(1);
            },
            loadData(page) {
                this.table.loading = true;
                util.ajax.get('/sim/list', {
                    params: {
                        page: page || this.table.page.current,
                        size: this.table.page.size,
                        orderKey: this.table.page.sortKey,
                        orderMethod: this.table.page.sortMethod,
                        keyword: this.table.page.keyword
                    }
                }).then((res) => {
                    this.table.loading = false;
                    res.data.list.forEach(item=>{
                        item.card_status = this.setCardStatus(item.card_status);
                        item.card_gen = item.card_gen?item.card_gen:2;
                        item.device_name = item.device_name?item.device_name:this.$t('l.unbound');
                    })
                    this.setPage(res.data);
                });
            },
            loadEchartData(){
                util.ajax.get("/sim/getecharts").then(res=>{
                    if (!res.code&&res.data){
                        Object.keys(res.data).forEach(key=>{
                            if (!res.data[key]) this.echartsData[key] = 0;
                            else this.echartsData[key] = res.data[key]
                        })
                    }
                })
            },
            pageSizeChange(val) {
                this.table.page.size = val;
                this.loadData(page);
            },
            changePage(page) {
                if (!this.table.page.keyword) this.loadData(page);
            },
            setPage(pageInfo) {
                pageInfo.list.forEach(row => {
                    if (this.batch.ids.includes(row.iccid)) this.$set(row, '_checked', true);
                    util.parseJSONResult(row, 'packages')
                });
                this.table.data = pageInfo.list;
                this.table.page.current = pageInfo.pageNumber;
                this.table.page.total = pageInfo.totalRow;
            },
            setCardStatus(status){
                switch (status) {
                    case "0":
                        return this.$t('l.inactivated');
                    case "1":
                        return this.$t('l.normal');
                    case "2":
                        return this.$t('l.arrears');
                    case "3":
                        return this.$t('l.out_service');
                    case "4":
                        return this.$t('l.account_cancel');
                    case "5":
                        return this.$t('l.will_expire');
                    case "6":
                        return this.$t('l.package_will_out');
                    case "7":
                        return this.$t('l.package_will_out2');
                    default :
                            return this.$t('l.unbound');;
                }
            },
            preEdit(terminal, index) {
                this.modal.currentIndex = index;
                this.modal.terminal = util.deepCopy(terminal);
                this.modal.title = this.$t('l.terminal');
                if (!terminal.j_extra_capacity) {
                    terminal.j_extra_capacity = {
                        video_talking: {
                            enable: false
                        },
                        one_key_help: {
                            enable: false
                        },
                        face_recognition: {
                            enable: false
                        },
                        mobile_control: {
                            enable: false
                        },

                    }
                }
                this.modal.showCard = true;
            },
            preAdd() {
                this.modal.community = {
                    name: '',
                    address: '',
                    j_buildings: [],
                    j_region: this.modal.j_region_temp
                }

                this.modal.title = this.$t('l.create_community');
                this.modal.showCard = true;
            },
            onSubmit() {
                // this.modal.loading = true;
                // let community = this.modal.community;
                // if (community.id) {
                //     util.ajax.put('/community/update', community).then(res => {
                //         this.modal.loading = false;
                //         if (!res.code) {
                //             this.modal.showCard = false;
                //             this.table.data.splice(this.modal.currentIndex, 1, this.modal.community);
                //             this.modal.currentIndex = -1;
                //             this.modal.selectedRegion = []
                //         }
                //     })
                // } else {
                //     util.ajax.post('/community/add', community).then(res => {
                //         this.modal.loading = false;
                //         if (!res.code) {
                //             this.modal.showCard = false;
                //             this.modal.selectedRegion = []
                //             this.loadData();
                //         }
                //     })
                // }

            },
            importDeviceInfo(f) {

            },
            onSelectionChange(selection) {
                if (!selection.length) {
                    this.table.data.forEach(c => {
                        this.onSelectCancel(null, c);
                    })
                } else selection.forEach(c => {
                    if (!this.batch.ids.includes(c.iccid))
                        this.batch.ids.push(c.iccid);
                })
            },
            onSelectCancel(selection, row) {
                this.batch.ids.splice(this.batch.ids.indexOf(row.iccid), 1);
            },
            onBatchClick() {
                this.current.drawer = 'recharge';
                this.current.drawerTitle = this.$t('l.pay');
                this.$refs.rechargeList.loadData();
                this.batch.showDrawer = true;
            },
            onShowOrder() {
                this.current.drawer = 'order';
                this.current.drawerTitle = this.$t('l.order');
                this.batch.showDrawer = true;
            },
            onOrderCreated() {
                this.batch.showDrawer = false;
                this.batch.ids.splice(0, this.batch.ids.length);
                this.$Modal.success({
                    title: this.$t('l.order_created'),
                    content: this.$t('l.remark106'),
                    okText: this.$t('l.confirm'),
                    onOk: () => {
                        this.$Modal.remove();
                        this.loadMyOrder();
                    },
                    onCancel: () => {
                        this.$Modal.remove();
                    }
                })
            },
            loadMyOrder() {
                util.ajax.get('/order/myorders').then(res => {
                    this.order.list = res.data.map(od => {
                        od.order_content = util.parseJSON(od.order_content);
                        return od;
                    });
                })
            },
            deleteSim(iccid) {
                util.ajax.delete(`/sim/delete`, {
                    params: {
                        iccid: iccid
                    }
                }).then(res => {
                    if (!res.code) {
                        this.$Message.success(this.$t('l.delete_success'));
                    }
                })
            },
            drawChart(that, census, option) {
                that = echarts.init(document.getElementById(census));
                that.clear();
                that.setOption(option)
            },
            addEventListener(that) {
                window.addEventListener("resize", () => {
                    if (that && that != {}) {
                        that.resize();
                    }
                })
            },
        },
        mounted(){
            this.$nextTick(()=>{
                this.drawChart(this.cardStatusChar, "sims", this.simEcharts); // 设备类型统计
                this.addEventListener(this.cardStatusChar)
            })
        },
        created() {
            this.loadData();
            this.loadMyOrder();
            this.loadEchartData();
        },
    };

</script>

<style lang="less" scoped>
    .btn-context-menu {
        & > span {
            cursor: pointer;
            margin: 0 3px;
            & > i {
                transition: transform 0.3s;
            }
            &:hover > i {
                transform: rotateY(180deg);
            }
        }

    }

    .pool-container li {
        margin: 0 5px;
        cursor: pointer;
        padding: 5px 0;
        border-bottom: 1px dashed #ddd;
    }

    .pool-container li.active {
        font-weight: bolder;
    }

    .form-item {
        margin-bottom: 0;
        color: #17233d;
        font-size: 14px;
        font-weight: 500;
    }

    .sim-statistics{
        height: 100%;
    }
</style>
